import { CloseIcon, IconButton } from '@farol-ds/react'
import classNames from 'classnames'

import { InternalHeader, InternalHeaderProps } from '../internal-header'
import styles from './login-card.module.scss'

interface LoginCardProps {
  header?: InternalHeaderProps
  children: React.ReactNode
  hideCloseButton?: boolean
  onCloseClick?: () => void
}

export function LoginCard({
  header = {},
  children,
  hideCloseButton = false,
  onCloseClick,
}: LoginCardProps) {
  return (
    <div className={styles.container}>
      <div className={styles.card}>
        {!hideCloseButton && (
          <div className={styles.closeButtonContainer}>
            {onCloseClick ? (
              <IconButton
                icon={<CloseIcon />}
                label="Fechar"
                className={styles.closeButton}
                size="md"
                onClick={onCloseClick}
              />
            ) : (
              <IconButton label="Fechar" className={styles.closeButton} size="md" asChild>
                <a href="https://www.jusbrasil.com.br">
                  <CloseIcon />
                </a>
              </IconButton>
            )}
          </div>
        )}
        <div
          className={classNames(styles.content, {
            [styles.contentWithoutClose]: hideCloseButton,
          })}
        >
          <InternalHeader {...header} />
          {children}
        </div>
      </div>
    </div>
  )
}
